<app-header></app-header>
<app-side-nav></app-side-nav>

<div class="container">
  <div class="vip-container" [ngStyle]="{ opacity: vip$.store.isLoadingPage ? '0' : '1' }">
    <div class="vip-container__top">
      <div class="vip-container__top--row" [class.auth-mobile]="user$.auth">
        <div class="vip-container__top--column">
          @if (!user$.auth) {
            <div class="vip-container__top--title">
              {{ vip$.store.page?.NoAuthTitle }}
            </div>
          }
          @if (user$.auth && !vip$.store.currentVipUserLevel) {
            <div class="vip-container__top--title">
              {{ 't.become-vip' | translate }}
            </div>
          }

          @if (user$.auth && vip$.store.currentVipUserLevel) {
            <div class="vip-container__top--level">
              <app-vip-level-label [isTitleOnly]="true" [levelName]="vip$.store.currentVipUserLevel?.LevelName"></app-vip-level-label>
            </div>
          }
          @if (user$.auth) {
            <app-vip-progress-bar></app-vip-progress-bar>
            @if (vip$.store.nextVipUserLevel) {
              <div class="desktop earn-spacer">
                <app-vip-earn></app-vip-earn>
              </div>
            }
          } @else {
            <div class="vip-container__top--desc">
              {{ vip$.store.page?.NoAuthDesc }}
            </div>
            @if (!user$.auth) {
              <div class="vip-container__top--image mobile noauth">
                <img class="vip-level" [src]="vip$.store.page?.NoAuthImage" alt="" />
              </div>
            }
            <div (click)="user$.authUser()" class="vip-container__top--action">
              <button class="btn btn--filled-primary">
                {{ user$.authKeyTranslate | translate }}
              </button>
            </div>
          }
        </div>
        <div class="vip-container__top--column">
          @if (user$.auth) {
            <div class="vip-container__top--image level">
              <img
                class="vip-level"
                [src]="!vip$?.store?.currentVipUserLevel ? vip$.store.nextVipUserLevel?.Image : vip$.store.currentVipUserLevel?.Image"
                alt=""
              />
            </div>
          }
          @if (!user$.auth) {
            <div class="vip-container__top--image desktop noauth">
              <img class="vip-level" [src]="vip$.store.page?.NoAuthImage" alt="" />
            </div>
          }
        </div>
      </div>
      @if (user$.auth && vip$.store.nextVipUserLevel) {
        <div class="mobile earn-spacer">
          <app-vip-earn></app-vip-earn>
        </div>
      }
    </div>
    @if (!user$.auth) {
      <div class="m-top m-bottom">
        <ng-container *ngTemplateOutlet="vipBenefits"></ng-container>
      </div>
      <div class="m-bottom">
        <ng-container *ngTemplateOutlet="howGetVip"></ng-container>
      </div>
      <div class="m-bottom">
        <ng-container *ngTemplateOutlet="levels"></ng-container>
      </div>
      <div class="m-bottom">
        <ng-container *ngTemplateOutlet="advantages"></ng-container>
      </div>
      <div class="m-bottom">
        <ng-container *ngTemplateOutlet="faq"></ng-container>
      </div>
    }
    @if (user$.auth && !vip$.store.currentVipUserLevel) {
      <div class="m-top m-bottom">
        <ng-container *ngTemplateOutlet="howGetVip"></ng-container>
      </div>
      @if (vip$.store.nextVipUserLevel) {
        <div class="m-bottom">
          <ng-container *ngTemplateOutlet="howEarn"></ng-container>
        </div>
      }
      <div class="m-bottom">
        <ng-container *ngTemplateOutlet="vipBenefits"></ng-container>
      </div>
      <div class="m-bottom">
        <ng-container *ngTemplateOutlet="levels"></ng-container>
      </div>
      <div>
        <ng-container *ngTemplateOutlet="faq"></ng-container>
      </div>
    }
    @if (user$.auth && vip$.store.currentVipUserLevel) {
      <div class="m-bottom">
        <ng-container *ngTemplateOutlet="managers"></ng-container>
      </div>
      @if (vip$.store.nextVipUserLevel) {
        <div class="m-bottom">
          <ng-container *ngTemplateOutlet="howEarn"></ng-container>
        </div>
      }
      <div>
        <ng-container *ngTemplateOutlet="bonuses"></ng-container>
      </div>
      <div class="m-bottom">
        <ng-container *ngTemplateOutlet="games"></ng-container>
      </div>
      <div class="m-bottom">
        <ng-container *ngTemplateOutlet="tournaments"></ng-container>
      </div>
      <div class="m-bottom">
        <ng-container *ngTemplateOutlet="levels"></ng-container>
      </div>
      <div>
        <ng-container *ngTemplateOutlet="faq"></ng-container>
      </div>
    }
    <app-bottom-navigation></app-bottom-navigation>
    <app-footer></app-footer>
  </div>
</div>

<ng-template #vipBenefits>
  <div class="vip-container__benefits">
    <div class="vip-container__benefits--title">
      {{ vip$.store.page?.VipBenefitsTitle }}
    </div>
    <div class="vip-container__benefits--row">
      @for (benefit of vip$.store.page?.Benefits; track $index) {
        <div class="vip-container__benefits--column">
          <div class="vip-container__benefits--image">
            <img [src]="'/assets/img/vip/benefits/' + $index + '.png'" alt="" />
          </div>
          <div class="vip-container__benefits--desc">
            {{ benefit?.title }}
          </div>
        </div>
      }
    </div>
    @if (!user$.auth) {
      <div (click)="user$.authUser()" class="vip-container__benefits--action">
        <button class="btn btn--filled-primary">
          {{ user$.authKeyTranslate | translate }}
        </button>
      </div>
    }
    @if (user$.auth) {
      <div class="vip-container__benefits--action">
        <button routerLink="/deposit" class="btn btn--filled-primary">
          {{ 'btn.deposit' | translate }}
        </button>
      </div>
    }
  </div>
</ng-template>

<ng-template #howGetVip>
  <div class="vip-container__info">
    <div class="vip-container__info--title">
      {{ vip$.store.page?.HowGetVipTitle }}
    </div>
    <div class="vip-container__info--row">
      @for (item of vip$.store.page?.HowGetVip; track $index) {
        <div class="vip-container__info--column">
          <div class="vip-container__info--column__row">
            <div class="vip-container__info--image">
              <img [src]="'/assets/img/vip/info/' + $index + '.png'" alt="" />
            </div>
            <div>
              <div class="vip-container__info--subtitle">
                {{ item?.title }}
              </div>
              <div class="vip-container__info--desc">
                {{ item?.desc }}
              </div>
            </div>
          </div>
          @if (user$.auth) {
            <div class="vip-container__info--auth-action">
              <button [routerLink]="item?.buttonUrl" class="btn btn--filled-primary">
                {{ item?.buttonName }}
              </button>
            </div>
          }
          @if ($index === 0 || $index === 1) {
            <div class="vip-container__info--column__suffix">
              {{ 't.or' | translate }}
            </div>
          }
        </div>
      }
    </div>
    @if (!user$.auth) {
      <div (click)="user$.authUser()" class="vip-container__info--action">
        <button class="btn btn--filled-primary">
          {{ user$.authKeyTranslate | translate }}
        </button>
      </div>
    }
  </div>
</ng-template>

<ng-template #howEarn>
  <div class="vip-container__earn">
    <div class="vip-container__earn--title">
      {{ vip$.store.page?.HowEarnPointsTitle }}
    </div>
    <div class="vip-container__earn--level">
      <app-vip-level-label [levelName]="vip$.store.nextVipUserLevel?.LevelName"></app-vip-level-label>
    </div>
    <div
      #rules
      class="vip-container__earn--rules m-top"
      [style.--content]="vip$.store.visibleRulesCount === vip$.store.nextVipUserLevel?.HowEarnVPoints?.length ? 'unset' : ''"
    >
      @for (
        rule of vip$.store.nextVipUserLevel?.HowEarnVPoints
          | slice: 0 : (isMobile() ? vip$.store.visibleRulesCount : vip$.store.nextVipUserLevel?.HowEarnVPoints.length);
        track $index
      ) {
        <div class="vip-container__earn--rules__item">
          <div class="vip-container__earn--rules__item--title">
            {{ rule?.title }}
          </div>
          <div class="vip-container__earn--rules__item--row">
            <div class="rules-inner" [class.first]="rule.firstDesc && rule.secondDesc">
              @if (rule.firstCondition) {
                <i class="icon-check-checkbox"></i>
              } @else {
                <img class="earn-img" src="/assets/img/vip/earn_1.png" />
              }
              <div
                [class.inactive]="rule?.firstCondition"
                [class.single]="!rule?.secondDesc"
                class="vip-container__earn--rules__item--first-rule"
                wrapHtml
                [rule]="rule?.firstDesc"
                [innerHTML]="rule?.firstDesc"
              ></div>
            </div>
            <div class="rules-inner">
              @if (rule.secondDesc && (rule.secondCondition || rule.thirdCondition)) {
                <i class="icon-check-checkbox"></i>
              } @else if (rule.secondDesc) {
                <img class="earn-img" src="/assets/img/vip/earn_2.png" />
              }
              <div
                class="vip-container__earn--rules__item--second-rule"
                [class.inactive]="rule?.secondCondition || rule?.thirdCondition"
                [style.--content-second-rule]="rule?.secondDesc ? '' : 'unset'"
                wrapHtml
                [rule]="rule?.secondDesc"
                [innerHTML]="rule?.secondDesc"
              ></div>
            </div>
          </div>
        </div>
      }
    </div>
    @if (vip$.store.nextVipUserLevel?.HowEarnVPoints?.length > vip$.store.visibleRulesCount && isMobile()) {
      <div (click)="showMore(vip$.store.nextVipUserLevel?.HowEarnVPoints?.length)" class="vip-container__earn--more">
        {{ 'btn.more' | translate }}
        <i class="icon-arrow"></i>
      </div>
    }
  </div>
</ng-template>
<ng-template #managers>
  <div class="vip-container__managers">
    <div class="vip-container__managers--column">
      <div class="vip-container__managers--title desktop">
        {{ 't.personal-vip-managers' | translate }}
      </div>
      @if (vip$.store.isShowManagers && vip$.store.page?.CurrentManager) {
        <div class="vip-container__managers--open">
          <div class="open-container">
            <div class="vip-container__managers--top__row">
              <div class="vip-container__managers--top__support-icon">
                <img [src]="'/assets/img/vip/manager/' + 0 + '.png'" alt="" />
              </div>
              @if (vip$.store.page?.CurrentManager) {
                <div class="vip-container__managers--top__support-content">
                  <div class="vip-container__managers--top__support-socials">
                    @if (vip$.store.page?.CurrentManager) {
                      {{ vip$.store.page?.CurrentManager?.name }}
                    } @else {
                      {{ 't.manager-assign-soon' | translate }}
                    }
                    @if (vip$.store.page?.CurrentManager?.telegramLink) {
                      <img class="social" src="/assets/img/vip/socials/telegram.png" alt="" />
                    }
                    @if (vip$.store.page?.CurrentManager?.whatsAppLink) {
                      <img class="social" src="/assets/img/vip/socials/whatsapp.png" alt="" />
                    }
                    @if (vip$.store.page?.CurrentManager?.email) {
                      <img class="social" src="/assets/img/vip/socials/email.png" alt="" />
                    }
                  </div>
                    <div class="manager-title">
                      {{ 't.can-be-manager' | translate }}
                    </div>
                </div>
              } @else {
                <div class="manager-title">
                  {{ 't.manager-assign-soon' | translate }}
                </div>
              }
            </div>
            @if (vip$.store.page?.CurrentManager) {
              <div class="arrow">
                <i (click)="vip$.toggleManagers()" class="icon-arrow open" src="/assets/img/vip/arrow-manager.png" alt=""></i>
              </div>
            }
            @if (vip$.store.page?.CurrentManager?.telegramLink) {
              <div class="manager">
                <div class="inner">
                  <img class="social" src="/assets/img/vip/socials/telegram.png" alt="" />
                  <a [href]="vip$.store.page?.CurrentManager?.telegramLink" target="_blank">{{
                    '@' + vip$.store.page?.CurrentManager?.telegramName
                  }}</a>
                </div>
                <div (click)="copy$.copy('', vip$.store.page?.CurrentManager?.telegramLink)">
                  <i class="icon-copy-new"></i>
                </div>
              </div>
            }
            @if (vip$.store.page?.CurrentManager?.whatsAppLink) {
              <div class="manager">
                <div class="inner">
                  <img class="social" src="/assets/img/vip/socials/whatsapp.png" alt="" />
                  <a [href]="vip$.store.page?.CurrentManager?.whatsAppLink" target="_blank">{{
                    '@' + vip$.store.page?.CurrentManager?.whatsAppName
                  }}</a>
                </div>
                <div (click)="copy$.copy('', vip$.store.page?.CurrentManager?.whatsAppLink)">
                  <i class="icon-copy-new"></i>
                </div>
              </div>
            }
            @if (vip$.store.page?.CurrentManager?.email) {
              <div class="manager">
                <div class="inner">
                  <img class="social" src="/assets/img/vip/socials/email.png" alt="" />
                  <a [href]="'mailto:' + vip$.store.page?.CurrentManager?.email" target="_blank">{{
                    vip$.store.page?.CurrentManager?.email
                  }}</a>
                </div>
                <div (click)="copy$.copy('', vip$.store.page?.CurrentManager?.email)">
                  <i class="icon-copy-new"></i>
                </div>
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="vip-container__managers--top">
          <div class="vip-container__managers--top__row">
            <div class="vip-container__managers--top__support-icon">
              <img [src]="'/assets/img/vip/manager/' + 0 + '.png'" alt="" />
            </div>
            <div class="vip-container__managers--top__support-content">
              <div class="vip-container__managers--top__support-socials">
                {{ vip$.store.page?.CurrentManager?.name }}
                @if (vip$.store.page?.CurrentManager?.telegramLink) {
                  <img class="social" src="/assets/img/vip/socials/telegram.png" alt="" />
                }
                @if (vip$.store.page?.CurrentManager?.whatsAppLink) {
                  <img class="social" src="/assets/img/vip/socials/whatsapp.png" alt="" />
                }
                @if (vip$.store.page?.CurrentManager?.email) {
                  <img class="social" src="/assets/img/vip/socials/email.png" alt="" />
                }
              </div>
              @if (vip$.store.page?.CurrentManager) {
                <div class="manager-title">
                  {{ 't.can-be-manager' | translate }}
                </div>
              } @else {
                <div class="manager-title">
                  {{ 't.manager-assign-soon' | translate }}
                </div>
              }
            </div>
          </div>
          @if (vip$.store.page?.CurrentManager) {
            <div class="arrow">
              <i (click)="vip$.toggleManagers()" class="icon-arrow" src="/assets/img/vip/arrow-manager.png" alt=""></i>
            </div>
          }
        </div>
      }
    </div>
    <div class="vip-container__managers--column">
      <div class="vip-container__managers--benefits">
        @for (benefit of vip$.store.page?.Benefits; track $index) {
          <div class="vip-container__managers--benefits__item">
            <div class="vip-container__managers--benefits__item--image">
              <img [src]="'/assets/img/vip/support/' + $index + '.png'" alt="" />
            </div>
            <div class="vip-container__managers--benefits__item--desc">
              {{ benefit?.title }}
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="vip-container__managers--action">
    <div class="btn btn--filled-primary" routerLink="/profile/deposit">{{ 'btn.deposit' | translate }}</div>
  </div>
</ng-template>
<ng-template #bonuses>
  @if (vip$.bonuses$.bonuses$ | async; as listTypes) {
    @if (listTypes[BonusStage.VIP].length) {
      <div class="vip-container__bonuses">
        <div class="vip-container__bonuses--title">
          {{ 't.special-vip-bonuses' | translate }}
        </div>
        <div class="grid">
          @for (bonus of listTypes[BonusStage.VIP]; track $index) {
            <app-bonus-preview
              [bonus]="bonus"
              [type]="bonus?.type"
              [buttonTitle]="'btn.use-bonus'"
              (onActivate)="activate($event)"
              (onCancel)="cancel($event)"
              (onCancelLootbox)="onCancelLootbox($event)"
              (onOpenLootbox)="onOpenLootbox($event)"
            >
            </app-bonus-preview>
          }
        </div>
      </div>
    }
  } @else {
    <app-preloader></app-preloader>
  }
</ng-template>
<ng-template #games>
  <div class="vip-container__games">
    <app-slider-game-list [config]="lastPlayedListConfig"></app-slider-game-list>
  </div>
</ng-template>
<ng-template #tournaments>
  @if (vip$.tournaments$ | async; as tournaments) {
    @if (tournaments.length) {
      <div class="vip-container__tournaments">
        <div class="vip-container__tournaments--title">
          {{ vip$.store.page?.VipTournamentsTitle }}
        </div>
        @for (tournament of tournaments; track $index) {
          <app-tournament-preview [tournamentItem]="tournament"></app-tournament-preview>
        }
      </div>
    }
  }
</ng-template>
<ng-template #levels>
  <div class="vip-container__levels">
    <i (click)="levelsSlider()?.slider?.prev()" class="icon-arrow vip-container__levels--left"></i>
    <i (click)="levelsSlider()?.slider?.next()" class="icon-arrow vip-container__levels--right"></i>
    <div class="vip-container__levels--title">
      {{ vip$.store.page?.VipLevelsTitle }}
    </div>
    <div class="vip-container__levels--desc">
      {{ vip$.store.page?.VipLevelsDesc }}
    </div>
    @if (vip$.store.vipLevels?.length) {
      <div class="vip-container__levels--row">
        <app-slider #levelsSlider [slideList]="vip$.store?.vipLevels" [config]="vip$.vipLevelsSliderConfig" [intersectionObserver]="false">
          @for (level of vip$.store?.vipLevels; track $index) {
            <div class="vip-container__levels--column">
              <div class="vip-container__levels--top">
                <div>
                  <div class="vip-container__levels--top__title">
                    {{ level.LevelName }}
                  </div>
                  <div class="vip-container__levels--top__desc">
                    {{ 't.v-points' | translate }}: <span>{{ level?.VPointsToReach }}</span>
                  </div>
                </div>
                <div class="vip-container__levels--top__image">
                  <img [src]="level?.Image" alt="" />
                </div>
              </div>
              <div class="vip-container__levels--benefits">
                @for (benefit of level.Benefits; track $index) {
                  <div class="vip-container__levels--benefits__item">
                    <div [style.color]="benefit.active ? '#FFFFFF' : '#868686'" class="vip-container__levels--benefits__title">
                      {{ benefit.title }}
                    </div>
                    @if (benefit.active) {
                      <i class="icon-check-checkbox"></i>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </app-slider>
        <div class="pagination-container">
          <ng-container *ngTemplateOutlet="levelsSlider?.paginationElement"></ng-container>
        </div>
      </div>
    }
  </div>
</ng-template>
<ng-template #advantages>
  <div class="vip-container__advantages">
    <div class="vip-container__advantages--title">
      {{ vip$.store.page?.VipAdvantagesTitle }}
    </div>
    <div class="vip-container__advantages--row">
      <div class="vip-container__advantages--content">
        <div class="vip-container__advantages--features">
          @for (feature of vip$.store.page?.VipAdvantagesFeatures; track $index) {
            <div class="vip-container__advantages--features__item">
              <div class="vip-container__advantages--features__item--image">
                <img [src]="'/assets/img/vip/advantages/' + $index + '.png'" alt="" />
              </div>
              <div class="vip-container__advantages--features__item--desc">
                {{ feature?.desc }}
              </div>
            </div>
          }
        </div>
        <div class="vip-container__advantages--play mobile">
          <div class="vip-container__advantages--play__image">
            <img [src]="vip$.store.page?.VipAdvantagesImage" alt="" />
          </div>
        </div>
        <div class="vip-container__advantages--play__info">
          <div class="vip-container__advantages--play__info--desc">
            {{ vip$.store.page?.VipAdvantagesDesc }}
          </div>
          <div (click)="user$.authUser()" class="vip-container__advantages--play__info--action">
            <button class="btn btn--filled-primary">
              {{ user$.authKeyTranslate | translate }}
            </button>
          </div>
        </div>
      </div>
      <div class="vip-container__advantages--play desktop">
        <div class="vip-container__advantages--play__image">
          <img [src]="vip$.store.page?.VipAdvantagesImage" alt="" />
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #faq>
  <div class="vip-container__faq">
    <app-bottom-terms [accordionTitle]="'link.faq' | translate" [terms]="vip$.store.page?.Faq"></app-bottom-terms>
  </div>
</ng-template>
